import './polyfills';
import main from '../main';

// console.log('promise', Promise);
main();
